module.exports = new __parcel__URL__("73091264-3.2f7e6bf0.png").toString();